// ForgotPassword.js
import "../styles/ForgotPasswordStyle.css";
import RightSide from ".././.././../assets/images/RightSide.png"; // Include your image
import ".././.././../styles/CommonStyles.css";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "../../../utils/Strings";
import { forgotPasswordEmail } from "../data/api/ForgotPasswordApiCall";
import { useApi } from "../../../service/ApiContext";
import Logger from "../../../utils/Logger";
import { useAlert } from "../../../components/AlertContextComponent";
import useReCaptchaBadge from "../../../service/UseCaptchaBadge";
import MailVerifyIcon from "../../login/assets/reset-password (1) 1.svg";
function ResetPasswordLink() {
  const navigate = useNavigate();
  const location = useLocation();
  const api = useApi();
  const email = location.state?.emailOrUid;
  const { showAlert } = useAlert();

  const handleResend = async () => {
    if (!email) {
      Logger.error("Email is missing. Unable to resend.");
      return;
    }

    try {
      await forgotPasswordEmail(api, email, showAlert);
    } catch (error) {
      Logger.error("Failed to resend email. Please try again.");
    }
  };
  return (
    // <div>
    //   <h1 className="heading">{strings.resetPassword.verifyEmailIdHeading}</h1>

    //   <p className="verifytext-styling">
    //     Password reset link sent to your email address: {email} Please follow
    //     the link to continue.
    //     {/* <a href="mailto:support@jozuna.com" className="email-link">
    //       {strings.resetPassword.verifyEmail}
    //     </a> */}
    //   </p>

    //   <p className="resendtext-styling">
    //     Didn't get the email?{" "}
    //     <span className="resend-link" onClick={handleResend}>
    //       {strings.resetPassword.resendTxt}
    //     </span>
    //   </p>
    //   <p className="backtologin-styling_p" style={{ marginTop: "20px" }}>
    //     <span className="backtologin-styling" onClick={() => navigate("/")}>
    //       {strings.ForgotPassword.backToLoginTxt}
    //     </span>
    //   </p>
    //   <div className="image-container1">
    //     <img src={RightSide} alt="logo" className="img-fluid bottom-image" />
    //   </div>
    // </div>
    <div className="v2-verify-wrapper">
      <h1 className="v2-verify-heading">
        {strings.resetPassword.verifyEmailIdHeading}
      </h1>

      {/* ICON */}
      <div className="v2-verify-icon-wrapper">
        <img
          src={MailVerifyIcon}
          alt="Verify Email"
          className="v2-verify-icon"
        />
      </div>

      {/* TEXT */}
      <div className="v2-verify-content">
        <p className="v2-verify-description">
          Password reset link sent to your email address:
        </p>

        <h4 className="v2-verify-email">{email}</h4>

        <p className="v2-verify-subtext">Please follow the link to continue.</p>
      </div>

      {/* RESEND BOX */}
      <div className="v2-verify-resend-box">
        <p className="v2-verify-resend-text">Didn't get the email?</p>

        <span className="v2-verify-resend-link" onClick={handleResend}>
          Click to resend
        </span>
      </div>

      {/* BACK TO LOGIN */}
      <p className="v2-verify-back-wrapper">
        <span className="v2-verify-back-link" onClick={() => navigate("/")}>
          {strings.ForgotPassword.backToLoginTxt}
        </span>
      </p>
    </div>
  );
}

export default ResetPasswordLink;
